import { Link } from '@apollo/orbit';
import { Restricted } from '@apollo/space-kit/illustrations/Restricted';
import React from 'react';

import * as orgRoutes from 'src/app/account/routes';

export const BillingManagerNoAccess = ({
  accountId,
}: {
  accountId: string;
}) => (
  <div className="flex size-full items-center justify-center">
    <div className="max-w-xl text-center">
      <Restricted className="mb-10" />
      <div className="mb-4 text-2xl font-semibold">No Access</div>
      <div>
        <div className="mb-4">
          As a billing manager, you do not have access to graph information.
        </div>
        <div>
          Billing statements and changes to billing information or plan can be
          found on the{' '}
          <Link to={orgRoutes.settings.location({ orgId: accountId })}>
            Settings Page
          </Link>
          , membership changes can be made on the{' '}
          <Link to={orgRoutes.members.location({ orgId: accountId })}>
            Members Page
          </Link>
          .
        </div>
      </div>
    </div>
  </div>
);
